export enum WidgetType {
    SELF_BOOKING = 'SELF_BOOKING',
    INQUIRY = 'INQUIRY',
    CONTRACTOR_RATING = 'CONTRACTOR_RATING',
    ADVANCED_SELF_BOOKING = 'ADVANCED_SELF_BOOKING',
    WIDGET_TEMPLATE = 'WIDGET_TEMPLATE',
}
